import { useGetList, type Identifier } from "ra-core";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import { sortReplies, type QuickReply } from "./quickReplies";

/** Team replies and the signed-in agent's own (RLS hides everyone else's). */
export const useQuickReplies = () => {
  const { data = [], refetch } = useGetList<QuickReply>("gula_quick_replies", {
    pagination: { page: 1, perPage: 200 },
    sort: { field: "sort", order: "ASC" },
  });
  return { replies: sortReplies(data), refetch };
};

export const saveQuickReply = async (reply: {
  id?: Identifier;
  label: string;
  body: string;
  ownerId: Identifier | null;
  sort?: number;
}) => {
  const supabase = getSupabaseClient();
  const row = {
    label: reply.label.trim(),
    body: reply.body.trim(),
    owner_id: reply.ownerId == null ? null : Number(reply.ownerId),
    ...(reply.sort != null ? { sort: reply.sort } : {}),
  };
  const { error } =
    reply.id != null
      ? await supabase
          .from("gula_quick_replies")
          .update(row)
          .eq("id", Number(reply.id))
      : await supabase.from("gula_quick_replies").insert(row);
  if (error) throw new Error(error.message);
};

export const deleteQuickReply = async (id: Identifier) => {
  const { error } = await getSupabaseClient()
    .from("gula_quick_replies")
    .delete()
    .eq("id", Number(id));
  if (error) throw new Error(error.message);
};
